import React, { Suspense, lazy } from 'react';

import { Drawer, Loader } from '@crehana/ui';
import Filter from '@crehana/icons/dist/outline/Filter';
import { primaryMain } from '@crehana/ui/dist/styles/colors';
import { useTranslation } from '@crehana/i18n';

import { useAppContext } from 'Jsx/Catalog/context/AppContext';

const LazyDrawerContent = lazy(
  () =>
    import(
      /* webpackChunkName: "catalog-mobile-filters" */
      './DrawerContent'
    ),
);

const FiltersMobile: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const { filters, filterActions } = useAppContext();

  const totalFilters: number =
    Object.keys(filters.softwaresSelected || {}).length +
    Object.keys(filters.levelsSelected || {}).length +
    Object.keys(filters.selectedLanguages || {}).length +
    filters.duration.selectedTags.length;

  const openDialog = () => setOpen(true);
  const closeDialog = () => {
    setOpen(false);
    filterActions.clearMobileFilters();
  };

  return (
    <div className="w-1/2 flex-shrink-0">
      <button
        type="button"
        onClick={openDialog}
        className="flex items-center justify-center w-full text-primary-main"
      >
        <Filter size={24} color={primaryMain} className="mr-8 min-w-24" />
        <span className="font-subtitle4 flex-shrink-0">
          {t('FILTER')} {totalFilters ? `(${totalFilters})` : null}
        </span>
      </button>

      <Drawer
        open={open}
        position="right"
        onDismiss={closeDialog}
        onEscape={closeDialog}
        unmountChildrenOnClose
      >
        <Suspense
          fallback={
            <div className="flex items-center justify-center w-full h-screen">
              <Loader />
            </div>
          }
        >
          <LazyDrawerContent closeDialog={closeDialog} />
        </Suspense>
      </Drawer>
    </div>
  );
};

export default FiltersMobile;
